
if(true){
    var s=document.createElement('script');
    s.src='https://vercel.live/_next-live/feedback/feedback.js';
    s.setAttribute("data-explicit-opt-in","true");s.setAttribute("data-deployment-id",process.env.NEXT_DEPLOYMENT_ID);
    ((document.head||document.documentElement).appendChild(s))
}